import { render, staticRenderFns } from "./careerCounselingDetail.vue?vue&type=template&id=787af46a&"
import script from "./careerCounselingDetail.vue?vue&type=script&lang=js&"
export * from "./careerCounselingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports